import React from 'react';
import Report from './Report';
import useBodyScrollLock from '../../shared/hooks/useBodyScrollLock';

const ViewReportModal = ({ isOpen, onRequestClose, report }) => {
    useBodyScrollLock(isOpen);

    if (!isOpen) return null;

    const handleBackgroundClick = (e) => {
        if (e.target === e.currentTarget) {
            onRequestClose();
        }
    };

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-50"
            onClick={handleBackgroundClick}
        >   
                <Report report={report} onRequestClose={onRequestClose} />
        </div>
    );
};

export default ViewReportModal;
